import { render, staticRenderFns } from "./dialogTemplate.vue?vue&type=template&id=4022a7ce&scoped=true&"
import script from "./dialogTemplate.vue?vue&type=script&lang=js&"
export * from "./dialogTemplate.vue?vue&type=script&lang=js&"
import style0 from "./dialogTemplate.vue?vue&type=style&index=0&id=4022a7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4022a7ce",
  null
  
)

export default component.exports